var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"spinner-container"},[_c('b-col',{staticClass:"text-center"},[_c('h1',{staticClass:"text-muted"},[_c('font-awesome-icon',{attrs:{"spin":"","icon":[ 'fa', 'spinner' ]}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }